module.exports = __webpack_public_path__ + "static/newsletter-image-26ed44bb755a5142fb5bd7361960aa0a.png";